// Constants
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
// Controls
import { SensitivityLabelPicker } from "../sensitivityLabelPicker/SensitivityLabelPicker";
import { SensitivityLabel } from "@ms/planner-models/lib/local/client/tenant/SensitivityLabel";
// Styles
import { useStyles } from "./RosterSettingsForm.styles";
// Utilities
import isEmpty from "lodash/isEmpty";
import React, { useState } from "react";
/**
 * RosterSettingsForm component
 */ export const RosterSettingsForm = ({ enableMIPLabels, userAccessibleTenantSensitivityLabels, plannerRoster, hasSharedContainers, canChangeSensitivity, currentSensitivityLabel: externalCurrentSensitivityLabel, onSensitivitySelected: externalOnSensitivitySelected })=>{
    const styles = useStyles();
    // Memoize currentLabel calculation to prevent unnecessary recalculations on every render
    const currentLabel = React.useMemo(()=>plannerRoster.assignedSensitivityLabel?.sensitivityLabelId ? SensitivityLabel.getSensitivityLabel(plannerRoster.assignedSensitivityLabel.sensitivityLabelId, userAccessibleTenantSensitivityLabels) : null, [
        plannerRoster.assignedSensitivityLabel?.sensitivityLabelId,
        userAccessibleTenantSensitivityLabels
    ]);
    const [internalCurrentSensitivityLabel, setInternalCurrentSensitivityLabel] = useState(currentLabel);
    // Use external state if provided, otherwise use internal state
    const currentSensitivityLabel = externalCurrentSensitivityLabel !== undefined ? externalCurrentSensitivityLabel : internalCurrentSensitivityLabel;
    /**
     * Select a sensitivity label
     * @param selectedSensitivityLabel Selected sensitivity label
     */ const onSensitivitySelected = (selectedSensitivityLabel)=>{
        if (externalOnSensitivitySelected) {
            externalOnSensitivitySelected(selectedSensitivityLabel);
        } else {
            setInternalCurrentSensitivityLabel(selectedSensitivityLabel);
        }
    };
    const renderSensitivityLabelPicker = ()=>{
        if (!enableMIPLabels || isEmpty(userAccessibleTenantSensitivityLabels)) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(SensitivityLabelPicker, {
            sensitivityLabelTitle: SensitivityLabel.getFullSensitivityTitle(currentSensitivityLabel?.id ?? "", userAccessibleTenantSensitivityLabels),
            userAccessibleTenantSensitivityLabels: userAccessibleTenantSensitivityLabels,
            onSensitivitySelected: onSensitivitySelected,
            canChangeSensitivity: canChangeSensitivity,
            currentSensitivityLabelId: currentSensitivityLabel?.id ?? ""
        });
    };
    const infoSection = /*#__PURE__*/ React.createElement("span", null, Strings.RosterSecuritySettings_RosterSecuritySettingsInfoSectionString);
    // The privacy string will need to be updated in the future
    // if shared containers ever expands to other container types in addition to file-based containers.
    const privacySection = /*#__PURE__*/ React.createElement("div", {
        className: styles.privacySection
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.privacyHeader
    }, Strings.PlanSettings_PrivacyLabel), hasSharedContainers ? Strings.Plan_Group_PrivacyText_WithSharedContainers : Strings.GroupSettings_VisibilityMode_Private);
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.root
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.rosterSettingsFormSection
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.rosterSettingsFormContent
    }, infoSection, privacySection, /*#__PURE__*/ React.createElement("div", {
        className: styles.rosterSensitivitySection
    }, renderSensitivityLabelPicker()))));
};
